// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Radio from '../../components/form/Radio';
import FormField from '../../components/form/Field';
import PhoneField from '../../components/form/PhoneField';
import * as Validator from '../../utils/validation';
import { useTranslation } from 'react-i18next';
import { getAccountId, getPartner, setAccountInfo } from '../../utils/storage';
import { persistPartnerRedirectUrl } from '../../utils/partnerRedirectFlow';
import { isValidPhoneNumber } from 'libphonenumber-js';
import i18n from 'i18next';
import { PhoneInput as Phone2 } from 'react-international-phone';
import 'react-international-phone/style.css';
import {
    AnalyticsEvent,
    markOtpStarted,
    trackRegistrationFailed,
    useAnalytics,
} from '../../analytics';
import useLogger from '../../hooks/useLogger';
import { ACCOUNT_ACTIONS, LOG_STATUSES } from '../../logging/LoggingConstants';
import RegistrationPage, {
    FORM_CONTENT_CLASS,
    RegistrationSubmitFooter,
} from '../../components/layouts/RegistrationPage';
import PrimarySubmit from '../../components/button/PrimarySubmit';
import { updateAccount } from '../../services/registration';
import { buildAccountPhonePayload } from '../../utils/phonePayload';
import { readPartnerInfo } from '../../utils/partnerRedirectFlow';
import PageHeader from '../../components/PageHeader';
import { FORM_LABEL_CLASS } from '../../components/form/formControlStyles';
import { cn } from '../../utils/cn';
import CustomButton from '../../components/customButton/CustomButton';
import infoIcon from '../../assets/svgs/info-icon.svg';
import PageLoaderOverlay from '../../components/loading/PageLoaderOverlay';

const DOCUMENT_TYPE = 1;

export default function Info() {
    const accountId = getAccountId();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const partner = getPartner();
    const [isValidEmail, setValidEmail] = useState(false);
    const [isValidSSN, setValidSSN] = useState(false);
    const [isValidPhone, setIsValidPhone] = useState(false);
    const [showErrorMsg, setShowErrorMsg] = useState(true);
    const [showErrorMsg1, setShowErrorMsg1] = useState(true);
    const [showErrorMsg2, setShowErrorMsg2] = useState(true);
    const ssnLocked = Boolean(partner?.docNumber);
    const [ssn, setSsnVal] = useState(partner?.docNumber != null ? String(partner.docNumber) : '');
    const [email, setEmailVal] = useState(partner?.email ?? '');
    const [phone, setPhoneVal] = useState(partner?.phone ?? '');
    const [isUSA, setUSA] = useState(2);
    const [isLoading, setIsLoading] = useState(false);
    const [dialCode, setDialCode] = useState(null);
    const [phoneDigits, setPhoneDigits] = useState(null);
    const { log } = useLogger();
    const { track } = useAnalytics();

    useEffect(() => {
        if (!partner) {
            return;
        }
        if (partner.email) {
            setValidEmail(true);
        }
        if (partner.docNumber) {
            setValidSSN(true);
        }
        if (partner.phone && isValidPhoneNumber(partner.phone)) {
            setIsValidPhone(true);
            const { code, phone: national } = buildAccountPhonePayload(partner.phone, null, null);
            setDialCode(code.replace(/^\+/, ''));
            setPhoneDigits(national);
        }
    }, [partner]);

    const checkValidEmail = ({ target }) => setValidEmail(Validator.isValidEmail(target.value));
    const checkValidSSN = ({ target }) => setValidSSN(Validator.isValidSSN(target.value));
    const checkValidPhone = (e) => setIsValidPhone(isValidPhoneNumber(e ? e : ''));

    const handleNodeEdit = () => {
        if (!accountId) {
            navigate('/');
            return;
        }

        setIsLoading(true);
        const { code: phoneCode, phone: phoneNational } = buildAccountPhonePayload(
            phone,
            dialCode,
            phoneDigits
        );
        const body = {
            email,
            code: phoneCode,
            phone: phoneNational,
            docType: DOCUMENT_TYPE,
            docNumber: partner?.docNumber ?? ssn,
            language: i18n.language,
            isUSA,
            partner: partner?.partner,
        };
        const partnerInfo = readPartnerInfo(partner?.partnerInfo);
        if (partnerInfo) {
            body.partnerInfo = partnerInfo;
        }
        setAccountInfo({
            email: body.email,
            ssn: body.docNumber,
            docNumber: body.docNumber,
        });
        updateAccount(accountId, body)
            .then((response) => {
                persistPartnerRedirectUrl(response);
                setAccountInfo(body);
                log(ACCOUNT_ACTIONS.UPDATE_ACCOUNT, LOG_STATUSES.SUCCESS);
                track(AnalyticsEvent.REGISTRATION_FORM_SUBMITTED);
                markOtpStarted('email');
                track(AnalyticsEvent.OTP_SENT, {
                    otp_type: 'email',
                    attempt: 1,
                    is_resend: false,
                    resend_count: 0,
                });
                navigate('/email');
            })
            .catch((e) => {
                trackRegistrationFailed({
                    step: 'registration_form',
                    error: e,
                    fallback: '3012',
                });
                const { message = '3012' } = e?.response?.data || {};

                navigate(`/error?errorCode=error${message}`);
            })
            .finally(() => setIsLoading(false));
    };

    const checkValueSsn = (e) => {
        setSsnVal(e.target.value);
        checkValidSSN(e);
        setShowErrorMsg(true);
    };

    const checkValueEmail = (e) => {
        setEmailVal(e.target.value);
        checkValidEmail(e);
        setShowErrorMsg1(true);
    };

    const checkValuePhone = (e) => {
        setPhoneVal(e ? e : '');
        checkValidPhone(e ? e : '');
        setShowErrorMsg2(true);
    };

    const submitDisabled =
        isUSA === 1 || !isValidEmail || !isValidPhone || !isValidSSN || isLoading;

    const handleSubmit = (event) => {
        event.preventDefault();
        if (submitDisabled) {
            return;
        }
        handleNodeEdit();
    };

    return (
        <>
            <PageLoaderOverlay active={isLoading} />
            <RegistrationPage
                headerProps={{ showBack: true }}
                contentClassName={cn(FORM_CONTENT_CLASS, 'xl:max-w-[30rem]')}
                contentTopClassName="mt-9 md:mt-16 lg:mt-16"
                stickyFooter
                footer={
                    <CustomButton
                        type="submit"
                        form="info-form"
                        disabled={submitDisabled}
                        className="md:w-fit md:mt-4"
                    >
                        {t('infoNext')}
                    </CustomButton>
                }
                
            >
                <PageHeader title={t('infoTitle')} align="start" />

                <form
                    id="info-form"
                    className="flex w-full flex-col gap-6"
                    onSubmit={handleSubmit}
                    noValidate
                >
                    <FormField
                        name="ssn"
                        type="text"
                        autoComplete="off"
                        label={t('labelSsn')}
                        placeholder={t('enterSsn')}
                        value={ssn}
                        disabled={ssnLocked}
                        error={t('errorSSNValid')}
                        showError={!showErrorMsg && !ssnLocked}
                        onBlur={() => (isValidSSN ? setShowErrorMsg(true) : setShowErrorMsg(false))}
                        onChange={checkValueSsn}
                    />

                    <FormField
                        name="email"
                        type="email"
                        autoComplete="email"
                        label={t('labelEmail')}
                        placeholder={t('enterEmail')}
                        value={email}
                        error={t('errorEmailValid')}
                        showError={!showErrorMsg1}
                        onBlur={() =>
                            isValidEmail ? setShowErrorMsg1(true) : setShowErrorMsg1(false)
                        }
                        onChange={checkValueEmail}
                    />

                    <PhoneField
                        id="phone"
                        name="phone"
                        autoComplete="tel"
                        label={t('labelPhone')}
                        value={phone}
                        error={t('errorPhoneValid')}
                        showError={!showErrorMsg2}
                        onBlur={() =>
                            isValidPhone ? setShowErrorMsg2(true) : setShowErrorMsg2(false)
                        }
                        onChange={(phoneNumber, meta) => {
                            const phoneNumberDigits = phoneNumber.startsWith(
                                '+' + meta?.country?.dialCode
                            )
                                ? phoneNumber.slice(meta?.country?.dialCode.length + 1).trim()
                                : meta?.inputValue?.replace(/\D/g, '');

                            checkValuePhone(phoneNumber);
                            setDialCode(meta?.country?.dialCode);
                            setPhoneDigits(phoneNumberDigits);
                        }}
                    />

                    <fieldset className="border-0 p-0 pb-4 text-left flex flex-col gap-2">
                        <legend id="info-usa-taxpayer-legend" className={cn(FORM_LABEL_CLASS)}>
                            {t('infoTaxpayer')}
                        </legend>
                        <Radio
                            name="isUSA"
                            aria-labelledby="info-usa-taxpayer-legend"
                            value={isUSA}
                            onChange={setUSA}
                            options={[
                                { label: t('firstRadio'), value: 1 },
                                { label: t('secondRadio'), value: 2 },
                            ]}
                        />
                        {isUSA === 1 ? (
                            <div className="flex items-start gap-2 p-4 rounded-lg bg-primary/10 border border-primary/10">
                                <img
                                    src={infoIcon}
                                    alt="info"
                                    aria-hidden="true"
                                    className="w-4 h-4"
                                />
                                <p className="text-custom-text-placeholder text-xs !leading-none mt-0.5 font-medium">
                                    {t('infoUsaTaxpayerWarning')}
                                </p>
                            </div>
                        ) : null}
                    </fieldset>
                </form>
            </RegistrationPage>
        </>
    );
}
